import processsearchresults from '../../_utilities/processsearchresults';
import recursiveLanguageResolve from '../../_utilities/recursive-language-resolve';

(() => {
  const reducer = () => (state, action) => {
    switch (action.type) {
      case 'UPDATE':
        state.items = action.value.items;
        state.totalItemCount = action.value.totalItemCount;
        break;

      default:
        break;
    }
    return state;
  };

  window.swinger
    .app({
      type: 'library-slider',
      component: 'library-slider',
      reducer: reducer(),
    })
    .then((app) => {
      console.log('Library slider initialized');

      const { language } = window.swinger.config;
      const state = app.store.getState();

      let componentName = 'card-movie';
      let keyName = 'movies';
      let apiUrl = `${window.swinger.config.apiRoutes.searchMovies}`;
      let dataSet = 'library';

      switch (state.kind) {
        default:
          break;

        case 'scene':
        case 'scenes':
          componentName = 'card-scene';
          keyName = 'scenes';
          apiUrl = `${window.swinger.config.apiRoutes.searchScenes}`;
          break;

        case 'category':
        case 'categories':
          componentName = 'card-category';
          keyName = 'categories';
          apiUrl = `${window.swinger.config.apiRoutes.searchCategories}`;
          dataSet = 'likes';
          break;
      }

      const cacheKey = `swinger.library-slider.${keyName}.${dataSet}`;

      const updateStore = (value) => {
        window.swinger.storage.set(cacheKey, value);

        app.store.dispatch({
          type: 'UPDATE',
          value,
        });
      };

      const retrieve = () => {
        const cachedData = window.swinger.storage.get(cacheKey);

        if (cachedData) {
          updateStore(cachedData);
        }

        window.swinger
          .ajax(`${window.swinger.config.apiBase}${apiUrl}?itemsPerPage=12&dataset=${dataSet}`)
          .then((result) => {
            const items = recursiveLanguageResolve(
              processsearchresults(result[keyName]),
              language,
            );
            const totalItemCount = result.pagination.totalItemCount || items.length;

            const value = {
              items: items.map((item) => ({
                component: componentName,
                data: item,
              })),
              totalItemCount,
            };
            updateStore(value);
          })
          .catch(console.error);
      };
      let lastAuthStatus = window.swinger.user.isLoggedIn();
      let initialized = false;
      const init = () => {
        const isLoggedIn = window.swinger.user.isLoggedIn();
        if (isLoggedIn === lastAuthStatus && initialized) {
          return;
        }
        lastAuthStatus = window.swinger.user.isLoggedIn();
        if (!isLoggedIn) {
          return;
        }
        retrieve();
        initialized = true;
      };
      document.addEventListener('swinger.user:authchange', () => {
        init();
      });
      init();
    })
    .catch(console.info);
})();



// WEBPACK FOOTER //
// ./src/widgets/library-slider/library-slider.js